import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PageLink, PageTitle } from "../../../../_metronic/layout/core";
import { PlansList } from "./PlansList";

const eventBreadcrumbs: Array<PageLink> = [
  {
    title: "Plans Management",
    path: "/plans/list",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];

const PlansPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="list"
          element={
            <>
              <PageTitle breadcrumbs={eventBreadcrumbs}>Plans list</PageTitle>
              <PlansList/>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to="/plans/list" />} />
    </Routes>
  );
};

export default PlansPage;
